export function load(callback) {
    if (document.readyState === 'loading') {
        list.push(callback);
    } else {
        // execute immediately if DOM is already loaded
        callback();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    list.forEach((callback) => callback());
    list.length = 0; // Clear the list after executing
});

const list = [];

window.load = load;
